import React, { useState, useEffect } from "react";
import styled from "styled-components";
import BookingStatusHeader from "./BookingStatusHeader";
import MobileViewLayout from "./MobileViewLayout";
import StatusChip from "./StatusChip";
import BookingStatusBody from "./BookingStatusBody";
import { useNavigate } from "react-router-dom";
import { fetchEmployeeBookingList } from "../../../services/bookingServices";
import { getFormattedBookingList, getFormattedDate } from "../../../helper";
import ErrorModal from "../../../components/ErrorSuccessModal/ErrorModal";
import { Pagination } from "../../../components/Pagination";
import { Colors } from "../../../config";
import { useLoaderContext } from "../../../contexts/loaderContext";
// import { useIntercom } from "react-use-intercom";
import { airports } from "../../../config/airports";
import dayjs from "dayjs";
import InputField from "../../../components/BusinessTripComponents/InputField";
const getDestination = (data) => {
  let res = airports.filter((port) => port.iata_code === data)[0];
  console.log(res);
  if (res?.city) {
    return `${res?.city || ""}, ${res?.iata_code || ""}`;
  } else {
    return data;
  }
};

export const BookingHeader = [
  {
    key: "requestID",
    label: "Request ID",
    content: (data) => (
      <RequestIDWrapper>
        {data.requestID}
        {data?.isBusinessTrip && <BusinessTrip>Business Trip</BusinessTrip>}
      </RequestIDWrapper>
    ),
  },
  {
    key: "requestDate",
    label: "Requested Date",
    content: (data) => (
      <DateDestinationWrapper>
        {getFormattedDate(data.requestDate, "MMM DD, YYYY")}
      </DateDestinationWrapper>
    ),
  },
  {
    key: "departureDate",
    label: "Departure Date",
    content: (data) => (
      <DateDestinationWrapper>
        {data.isBusinessTrip ? (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              {data?.travelDetails.map((td) => (
                <div>{getFormattedDate(td.departureDate, "MMM DD, YYYY")}</div>
              ))}
            </div>
          </>
        ) : (
          data.departureDate
        )}
      </DateDestinationWrapper>
    ),
  },
  {
    key: "returnDate",
    label: "Return Date",
    content: (data) => (
      <DateDestinationWrapper>
        {data.isBusinessTrip ? (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              {data?.travelDetails.map((td) => (
                <div>
                  {td.returnDate
                    ? getFormattedDate(td.returnDate, "MMM DD, YYYY")
                    : "NA"}
                </div>
              ))}
            </div>
          </>
        ) : (
          data.returnDate
        )}
      </DateDestinationWrapper>
    ),
  },
  {
    key: "destination",
    label: "Destination",
    content: (data) => (
      <DateDestinationWrapper>
        {data?.isBusinessTrip ? (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              {data?.travelDetails.map((td) => (
                <div>
                  {td.from} - {td.to}
                </div>
              ))}
            </div>
          </>
        ) : (
          <>{getDestination(data.destination)}</>
        )}
      </DateDestinationWrapper>
    ),
  },
  {
    key: "status",
    label: "Status",
    content: (data) => <StatusChip status={data.status.toLowerCase()} />,
  },
];

const BookingStatus = () => {
  const { setLoader } = useLoaderContext();
  const navigate = useNavigate();
  const [isTableDataLoading, setIsTableDataLoading] = useState(false);
  const [backendErrorMsg, setBackendErrorMsg] = useState(false);
  const [bookingListData, setBookingListData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  // const { boot, update, shutdown } = useIntercom();
  const employeeDetails = localStorage.getItem("employeeData");
  const employee = JSON.parse(employeeDetails);

  const handleBoxClick = (id) => {
    navigate(`/user/bookings/status/${id}`);
  };

  const fetchBookingList = async () => {
    setIsTableDataLoading(true);
    // setLoader(true);
    try {
      let { data } = await fetchEmployeeBookingList(page, search);
      if (data.code === 200) {
        // setLoader(false);
        let formattedBookingList = getFormattedBookingList(data?.data);
        setBookingListData(formattedBookingList);
        setCount(data?.count);
        // setIsTableDataLoading(false);
        // boot();
        // update({
        //   name: employee.firstName + " - " + data?.data[0]?.requestId,
        //   userId: data?.data[0]?.requestId,
        //   email: employee.email,
        // });
        // shutdown();
      }
    } catch (error) {
      // setLoader(false);
      setBackendErrorMsg(error.message);
    } finally {
      setIsTableDataLoading(false);
      // setLoader(false);
    }
  };

  const closeErrorModal = () => {
    setBackendErrorMsg(false);
  };

  useEffect(() => {
    fetchBookingList();
  }, [page, search]);

  return (
    <BookingStatusContainer>
      <SearchMainContainer>
        <SearchContainer>
          <InputField
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
            isRounded
            placeholder="Type here to search..."
            leftImg={require("../../../assets/images/search-normal.png")}
          />
        </SearchContainer>
      </SearchMainContainer>

      <DesktopView>
        <BookingStatusHeader />
        <BookingStatusBody
          bookingList={bookingListData}
          isTableDataLoading={isTableDataLoading}
          handleClick={handleBoxClick}
        />
      </DesktopView>
      <MobileView>
        <MobileViewLayout
          bookingList={bookingListData}
          isTableDataLoading={isTableDataLoading}
          handleClick={handleBoxClick}
        />
      </MobileView>
      {count > 0 && (
        <Pagination
          isTableDataLoading={isTableDataLoading}
          totalData={count}
          currentPage={page}
          rowsPerPage={10}
          totalPages={Math.ceil(count / 10)}
          onPageChange={(page) => setPage(page)}
        />
      )}
      {backendErrorMsg && (
        <ErrorModal
          subheaderText={backendErrorMsg}
          setClose={closeErrorModal}
          onButtonClick={closeErrorModal}
        />
      )}
    </BookingStatusContainer>
  );
};

export default BookingStatus;

const BookingStatusContainer = styled.div`
  padding: 1rem 3.125rem;
  @media only screen and (max-width: 850px) {
    padding: 1rem;
  }
`;
const DesktopView = styled.div`
  @media only screen and (max-width: 850px) {
    display: none;
  }
`;
const MobileView = styled.div`
  @media only screen and (min-width: 851px) {
    display: none;
  }
`;

const RequestIDWrapper = styled.div`
  color: ${Colors.brandTwo};
  font-weight: 500;
  font-size: 1.125rem;
`;

const DateDestinationWrapper = styled.div`
  color: ${Colors.shark};
  font-weight: 600;
  font-size: 1.125rem;
`;

const BusinessTrip = styled.div`
  font-size: 12px;
  padding: 4px 6px;
  border-radius: 4px;
  background: #fad56f;
  margin-top: 4px;
  font-weight: 400;
  color: black;
  width: fit-content;
`;

const SearchMainContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const SearchContainer = styled.div`
  // display: flex;
  width: 300px;
  margin-bottom: 1rem;
  @media only screen and (max-width: 850px) {
    width: 100%;
  }
`;
